import * as actions from './productSearchActionsConstants';
import * as steps from './productSearchStepConstants';
import {PSEUDO_CITY, STATION} from './stationTypeConstants';
import getStationsFromStationResult from '../utils/getStationsFromStationResult';
import moment from 'moment';
import {buildSearchParams} from './productSearchReducer';

export * from './actions/DomainEvents';

export function initProductSearchStateFromServer(serverState) {

  let processedServerState = {...serverState};
  let {flight_type, add_flight, deep_link} = processedServerState;

  // "flight_type", "deep_link" are not part of the productSearch Reducer
  // and remove from the object to avoid poluting the redux state
  delete processedServerState['flight_type'];
  delete processedServerState['deep_link'];

  let step;
  if (deep_link) {
    step = steps.PRODUCT_SEARCH_FORM
  } else {
    // Determine step based off flight_type value
    switch(flight_type){
      case 'schedule':
        if(add_flight) {
          step = steps.ADD_FLIGHT;
        } else {
          step = steps.DATE_SEARCH;
        }
        break;
      case 'crowdsource':
      case 'shared_charter':
      case 'charter':
        let {
          origin_station_result: { result_type: origin_type },
          destination_station_result: { result_type: destination_type }
        } = processedServerState;

        if(destination_type === PSEUDO_CITY) {
          step = steps.DESTINATION_FILTER;
        } else if(origin_type === PSEUDO_CITY) {
          step = steps.ORIGIN_FILTER;
        } else {
          step = steps.CHARTER_TIME_SELECTION;
        }
        break;
      default:
        // send to beginning
        step = steps.PRODUCT_SEARCH_FORM;

        processedServerState.destination_search_container = {
          back: 'ProductSearch',
          hideOnCancel: processedServerState.embedded
        };
    }
  }
  processedServerState.step = step;

  return { type: actions.INIT_SERVER_STATE, processedServerState }
}

export function openProductSearch() {
  return { type: actions.PRODUCT_SEARCH_OPEN }
}

export function openTimeSelection() {
  return { type: actions.CHARTER_TIME_SELECTION_OPEN, crowdsource: false };
}

export function openCrowdsourceSearch() {
  return { type: actions.CHARTER_TIME_SELECTION_OPEN, crowdsource: true};
}

export function openSharedCharterSearch() {
  return { type: actions.CHARTER_TIME_SELECTION_OPEN, shared_charter: true};
}

export function openOriginFilter(back=false) {
  return function(dispatch, getState) {
    let {result_type} = getState().productSearch.origin_station_result;
    if(result_type === PSEUDO_CITY) {
      dispatch({ type: actions.ORIGIN_FILTER_OPEN});
    } else if(back) {
      // hack we need better routing
      dispatch(openTimeSelection());
    } else {
      dispatch(openDestinationFilter());
    }
  }
}

export function openDestinationFilter() {
  return function(dispatch, getState) {
    let {productSearch} = getState();
    let {result_type} = productSearch.destination_station_result;
    let {crowdsource, shared_charter} = productSearch.charter_search_form;
    let flight_type;
    if (shared_charter) {
      flight_type = 'shared_charter'
    } else if (crowdsource) {
      flight_type = 'crowdsource'
    } else {
      flight_type = 'charter'
    }

    if(result_type === PSEUDO_CITY) {
      dispatch({ type: actions.DESTINATION_FILTER_OPEN});
    } else {
      dispatch(goToResultsPage(flight_type));
    }
  }
}

export function openOrigins({ back }) {
  return {
    type: actions.ORIGIN_SEARCH_OPEN,
    back: back
  };
}

export function openDestinations({ back }) {
  return {
    type: actions.DESTINATION_SEARCH_OPEN,
    back: back
  };
}

export function openDates() {
  return { type: actions.DATE_SEARCH_OPEN }
}

const selectStationResult = (action_type, station_result) => {
  let result_type;
  try {
    // station_result should be an object with result_type property
    result_type = station_result.result_type;
  } catch(e) { return {type: 'NOOP'}; }

  let valid_result_type = (
        result_type !== STATION ||
        result_type !== PSEUDO_CITY
      ),
      valid_action_type = (
        action_type !== actions.ORIGIN_STATIONS_SELECTED ||
        action_type !== actions.DESTINATION_STATIONS_SELECTED
      );

  if(!valid_result_type || !valid_action_type) { return {type: 'NOOP'}; }

  let label = station_result.title,
      stations = (station_result.result_type === STATION) ?
        [station_result] : station_result.sub_stations;

  return { type: action_type, station_result, label, stations }
}

export function selectOrigins(station_result) {
  return selectStationResult(actions.ORIGIN_STATIONS_SELECTED, station_result);
}

export function selectDestinations(station_result) {
  return selectStationResult(actions.DESTINATION_STATIONS_SELECTED, station_result);
}

export function swapStationValues() {
  return { type: actions.SWAP_STATION_VALUES }
}

export function filterOrigins(station_result) {
  let {
    result_type,
    title: label
  } = station_result;
  let stations = [station_result];

  if(result_type !== STATION) { return {type: 'NOOP'}; }

  return {type: actions.ORIGIN_STATIONS_FILTERED, label, stations};
}

export function filterOriginsAndContinue(station_result) {
  return function(dispatch) {
    dispatch(filterOrigins(station_result));
    dispatch(openDestinationFilter());
  }
}

export function filterDestinations(station_result) {
  let {
    result_type,
    title: label
  } = station_result;
  let stations = [station_result];

  if(result_type !== STATION) { return {type: 'NOOP'}; }

  return {type: actions.DESTINATION_STATIONS_FILTERED, label, stations};
}

export function filterDestinationsAndContinue(station_result) {
  return function(dispatch, getState) {
    let {productSearch} = getState();
    let {crowdsource} = productSearch.charter_search_form;
    let flight_type = crowdsource ? 'crowdsource': 'charter';

    dispatch(filterDestinations(station_result));
    dispatch(goToResultsPage(flight_type));
  }
}

export function selectPassengerQuantity(quantity) {
  return { type: actions.PASSENGER_QUANTITY_SELECTED, quantity }
}

export function setFlightAlert(boolean) {
  return { type: actions.FLIGHT_ALERT_SET, boolean }
}

export function selectTravelDate(momentObject) {
  return function(dispatch) {
    let date;
    if(moment.isMoment(momentObject)) {
      date = momentObject.toDate();
    }
    dispatch({ type: actions.TRAVEL_DATE_SELECTED, date });
    // time should be cleared so it can be revalidated
    dispatch(resetTravelTime());
  }
}

export function selectTravelDateAndContinue(momentObject) {
  return function(dispatch) {
    dispatch(selectTravelDate(momentObject));
    dispatch(goToResultsPage('schedule'));
  }
}

export function resetTravelTime() {
  return function(dispatch) {
    dispatch({ type: actions.TRAVEL_TIME_RESET });
  }
}

export function selectTravelTime(time) {
  return function(dispatch) {
    dispatch({ type: actions.TRAVEL_TIME_SELECTED, time: time });
    dispatch(validateTime());
  }
}

export function validateTime() {
  return function(dispatch, getState) {
    let {productSearch} = getState();
    let origins = getStationsFromStationResult(productSearch.origin_station_result);
    let destinations = getStationsFromStationResult(productSearch.destination_station_result);

    fetch(
      '/flight_search/validate_time?' +
        $.param({
          depart_date: moment(productSearch.travel_date_selection).format('YYYY-MM-DD'),
          depart_time: productSearch.travel_time_selection,
          origin_codes: origins.map(x => x.code),
          destination_codes: destinations.map(x => x.code)
        })
    ).
    then(response => response.json()).
    then(data => {
      let {errors} = data;
      dispatch({
        type: actions.TRAVEL_TIME_VALIDATED,
        error: Array.isArray(errors) ? errors.join('<br>') : null
      })
    });
  }
}

export function validateStations(origins, destinations) {
  return function(dispatch, getState) {
    let state = getState().productSearch;

    dispatch({ type: actions.STATIONS_VALIDATION_LOADING });

    fetch(
      '/flight_search/validate_stations?' +
        $.param({
          depart_date: moment(state.travel_date_selection).format('YYYY-MM-DD'),
          depart_time: state.travel_time_selection,
          origin_codes: origins.map(x => x.code),
          destination_codes: (Array.isArray(destinations) ? destinations.map(x => x.code) : null)
        })
    ).
    then(response => response.json()).
    then(data => {
      let { origins, destinations } = data;
      dispatch({ type: actions.STATIONS_VALIDATED, origins, destinations });
    });
  }
}

export function calendarParameters() {
  return function(dispatch, getState) {
    let {productSearch} = getState();
    let origins = getStationsFromStationResult(productSearch.origin_station_result);
    let destinations = getStationsFromStationResult(productSearch.destination_station_result);
    let {passenger_quantity} = productSearch;

    return fetch(
      '/flight_search/calendar_parameters?' +
        $.param({
          origin_codes: _.map(origins, x => x.code),
          destination_codes: _.map(destinations, x => x.code),
          requested_pax_count: passenger_quantity
        }),
      {
        headers: {
          'Content-Type': 'application/json'
        },
        credentials: 'same-origin'
      }
    ).
    then(response => response.json()).
    then(data => {
      dispatch({
        type: actions.CALENDAR_PARAMETERS_SUCCESS,
        dates_with_flights: data.published_flight_dates,
        closed_weekdays: data.closed_weekdays,
        closed_dates: data.closed_dates
      });
    });
  }
}

export function priceDate(origin_selections, destination_selections, depart_date, passenger_quantity) {
  return function(dispatch) {
    dispatch({ type: actions.PRICE_DATE_LOADING });

    return fetch(
        '/flight_search/price_date?' +
        $.param({
          origin_codes: _.map(origin_selections, x => x.code).join(','),
          destination_codes: _.map(destination_selections, x => x.code).join(','),
          depart_date,
          passenger_quantity
        })
      ).
      then(response => response.json()).
      then(data => {
        dispatch({
          type: actions.PRICE_DATE_SUCCESS,
          options: data
        });
      });
  }
}

export function goToResultsPage(flight_type) {
  if (
    flight_type !== 'schedule' &&
    flight_type !== 'charter' &&
    flight_type !== 'crowdsource' &&
    flight_type !== 'shared_charter'
  ) return {type: 'NOOP'};
  return function(dispatch, getState) {
    const params = buildSearchParams(getState(), flight_type);
    const queryString = new URLSearchParams(params).toString();
    const url = `${searchEndPoint}?${queryString}`;
    window.location.href = url;
    return {type: 'NOOP'};
  };
}
